export function initPostSliders(Glide) {
  const postSliders = document.querySelectorAll('.js-post-slider');

  if (postSliders) {
    postSliders.forEach((slider) => {
      // Do not initialize for sliders with only one slide
      if (slider.getAttribute('data-is-static') === 'true') {
        return;
      }
      // Set up track attribute
      slider
        .querySelector('.glide__track')
        .setAttribute('data-glide-el', 'track');

      // Initialize Glide instance
      const PostSlider = new Glide(slider, {
        startAt: 0,
        perView: 2,
        gap: 24,
        peek: 0,
        breakpoints: {
          390: {
            perView: 1,
            gap: 12,
          },
        },
      });

      // Button references
      const mobileArrows = slider
        .querySelector('.c-post-slider__mobile-controls')
        .querySelectorAll('button');
      const prevArrow = slider
        .querySelector('.c-post-slider__control--prev')
        .querySelector('button');
      const nextArrow = slider
        .querySelector('.c-post-slider__control--next')
        .querySelector('button');

      const prevButtons = [prevArrow]; // Fixed array creation
      const nextButtons = [nextArrow]; // Fixed array creation

      // Add mobile buttons if they exist
      if (mobileArrows.length >= 2) {
        prevButtons.push(mobileArrows[0]);
        nextButtons.push(mobileArrows[1]);
      }

      const slides = slider.querySelectorAll('.glide__slide');
      const firstSlide = slides[0];
      const lastSlide = slides[slides.length - 1];

      // Slide change handler
      const handleSlideChange = () => {
        if (firstSlide.classList.contains('glide__slide--active')) {
          prevButtons.forEach((button) =>
            button.setAttribute('disabled', 'true')
          );
        } else {
          prevButtons.forEach((button) => button.removeAttribute('disabled'));
        }

        if (lastSlide.classList.contains('glide__slide--active')) {
          nextButtons.forEach((button) =>
            button.setAttribute('disabled', 'true')
          );
        } else {
          nextButtons.forEach((button) => button.removeAttribute('disabled'));
        }
      };

      // Set up event handlers
      PostSlider.on('run.after', handleSlideChange);

      // Initial setup
      PostSlider.on('mount.after', handleSlideChange);

      // Mount the slider
      PostSlider.mount();
    });
  }
}
